// GLOBALS VARIABLES
// =================

var config = {
	headers : {
		'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
	}
};

var $grid;
var $gridList;

// FUNCTIONS
// =========

function loader(fadeOutDelay){
  $('.fade--in').fadeOut(fadeOutDelay, function() {
    $('.fade--in').fadeIn('slow');
  });
}

function scrollTop(scrollTopY){
	if (scrollTopY !== 0) {
		$('html,body').animate({
			scrollTop: scrollTopY
		}, 500);
	} else {
		$('html,body').animate({
			scrollTop: 1
		}, 500);
	}
}

function initIsotopeImage(){
	// init Isotope
	$grid = $('.grid').isotope({
	  itemSelector: '.grid-item',
	  layoutMode: 'fitRowsCentered',
    columnWidth: '.grid-sizer',
	});
	// layout Isotope after each image loads
	$grid.imagesLoaded().progress(function() {
		 $('.grid').isotope({
		  itemSelector: '.grid-item',
		  layoutMode: 'fitRowsCentered',
	    columnWidth: '.grid-sizer',
		});
	});

}

function initIsotopeList(){
	// init Isotope
	$gridList = $('.grid-list').isotope({
	  itemSelector: '.grid-list-item',
	  layoutMode: 'fitRowsCentered',
    columnWidth: '.grid-list-sizer',
	});
	// layout Isotope after each image loads
	$gridList.imagesLoaded().progress(function() {
		 $('.grid-list').isotope({
		  itemSelector: '.grid-list-item',
		  layoutMode: 'fitRowsCentered',
	    columnWidth: '.grid-list-sizer',
		});
	});
}

function isotopeLayout($scope){

  if ($scope.display === 'list') {
		$gridList.isotope('layout');
		$gridList.imagesLoaded().progress(function() {
			$gridList.isotope('layout');
		});
  } else {
		$grid.isotope('layout');
		$grid.imagesLoaded().progress(function() {
			$grid.isotope('layout');
		});
  }

}

function isotopeFilter(event, $scope, $timeout){
	// filter
  var filterValue = event.target.attributes['data-filter'].value;
  var filterName = event.target.attributes['data-name'].value;

  if ($scope.display === 'list') {
		$gridList.isotope({ filter: filterValue });
		$gridList.imagesLoaded().progress(function() {
			$gridList.isotope({ filter: filterValue });
		});
  } else {
		$grid.isotope({ filter: filterValue });
		$grid.imagesLoaded().progress(function() {
			$grid.isotope({ filter: filterValue });
		});
  }

  // active class
  $('.filter__list li').removeClass('active');
	$('.filter__list').find('li[data-name="'+filterName+'"]').addClass('active');

  // scroll top
  scrollTop(0);
	
	// define scope
	$timeout(function(){
    $scope.$apply(function(){
  		if (filterValue != '*') {
  			$scope.currentCat = filterName;
  			$scope.currentCatClass = filterValue;
  		} else {
  			$scope.currentCat = '';
  			$scope.currentCatClass = '*';
				$scope.showFiltersCat = false;
  		}
			return $scope.currentCat, $scope.currentCatClass;
    });
	});
}

function resetFilter($scope, $timeout){

	// reset filter
	$grid.isotope({ filter: '*' });
	$grid.imagesLoaded().progress(function() {
		$grid.isotope({ filter: '*' });
	});

	$gridList.isotope({ filter: '*' });
	$gridList.imagesLoaded().progress(function() {
		$gridList.isotope({ filter: '*' });
	});

  // reset active class
  $('.filter__list li').removeClass('active');
  $('.filter__list li[data-filter="*"]').addClass('active');

  // reset currentCat
	$timeout(function(){
	  $scope.$apply(function(){
			$scope.currentCat = '';
			$scope.currentCatClass = '*';
			$scope.showFiltersCat = false;
			return $scope.currentCat, $scope.currentCatClass;
	  });
  });
}


// BODY CONTROLLER
// ================

app.controller('bodyCtrl', ['$rootScope', '$scope', '$http', '$route', '$location', '$routeParams', '$timeout', '$window', function($rootScope, $scope, $http, $route, $location, $routeParams, $timeout, $window){
	// console.log("bodyCtrl");

    // root scope
		$rootScope.$on('$routeChangeSuccess', function(event, currentRoute, previousRoute) {
			console.log('route change');

      // var 
			$scope.$route = $route;
			$scope.$location = $location;
			$scope.$routeParams = $routeParams;
			$scope.originalPath = currentRoute.$$route.originalPath;
			$scope.siteUrl = $scope.$location.$$protocol + '://' + $scope.$location.$$host + '/';
			$scope.currentUrl = $scope.$location.$$absUrl;

      // close mobile menu
			$scope.closeMobileMenu = function(){
				$('body').removeClass('mobileNav--open');
				$('.hamburger').removeClass('hamburger--open');
			};
			$scope.closeMobileMenu();


      // fadeIn on route change
			loader('fast');

			// load custom data by route
			if ($scope.$route.current.params.workSlug){

				// load data
				$rootScope.loadWorkDetails($scope.$route.current.params.workSlug);

			} else if($scope.originalPath == '/contact'){

				// load data
				$rootScope.loadContact();

			} else {

				// load data
				$rootScope.loadHomepage();

			}

		});


    $scope.$on('LastRepeaterElementImages', function(){
			// console.log('LastRepeaterElementImages');

			// load isotope
    	initIsotopeImage();

    	// $timeout(function(){
    	// 	isotopeLayout($scope);
    	// },200);
    });

    $scope.$on('LastRepeaterElementList', function(){
			// console.log('LastRepeaterElementList');

			// load isotope
    	initIsotopeList();

    	// $timeout(function(){
    	// 	isotopeLayout($scope);
    	// },200);
    });

   	$scope.$watch('display', function() {
   		// fadeIn
    	loader(1);

    	// get back the filter when display change
    	var currentCatClass = $scope.currentCatClass;
    	if ($scope.display === 'list') {
    		if (currentCatClass !== undefined) {
    			$timeout(function(){
						$gridList.isotope({ filter: currentCatClass });
						$gridList.imagesLoaded().progress(function() {
							$gridList.isotope({ filter: currentCatClass });
						});
    			});
    		}
    	} else {
    		if (currentCatClass !== undefined) {
    			$timeout(function(){
						$grid.isotope({ filter: currentCatClass });
						$grid.imagesLoaded().progress(function() {
							$grid.isotope({ filter: currentCatClass });
						});
    			});
    		}
    	}
    });

		$scope.onReady = function(event){
			$scope.$broadcast('dataTitleHeaderLoaded');
		};

		$scope.scrollTop = function(){
			scrollTop(0);
		};

		$scope.isotopeLayout = function(){
			isotopeLayout($scope);
		};

		$scope.isotopeFilter = function(event){
			isotopeFilter(event, $scope, $timeout);
		};

		$scope.resetFilter = function(){
			resetFilter($scope, $timeout);
		};

		$scope.catFilterFromDetails = function(event){
			isotopeFilter(event, $scope, $timeout);
		};

		$scope.getScrollPosition = function(){
      $scope.scrollY = $window.scrollY;
      return $scope.scrollY;
		};

		$scope.setScrollPosition = function(){
      $timeout(function(){
				scrollTop($scope.scrollY);
      },50);
		};


}]);


// PAGES CONTROLLER
// ================
app.controller('pagesCtrl', ['$rootScope', '$scope', '$http', '$location', function($rootScope, $scope, $http, $location){
	// console.log('pagesCtrl');

	$scope.page = [];

	$rootScope.loadHomepage = function(config){
		console.log('load homepage data');
		$http.get('homepage.json', config).then(
			function successCallback(response) {
				$scope.page = response.data.data[0];
				// console.log($scope.page);
				$scope.$broadcast('dataTitleHeaderLoaded');

				// SEO title | description
				document.title = $scope.page.title;
				var desciptionTag = 'Pam&Jenny est un studio de design graphique situé à Bruxelles.';
				$('meta[name=description]').attr('content', desciptionTag);
			}
		);
	};

	$rootScope.loadContact = function(config){
		console.log('load contact data');
		$http.get('contact.json', config).then(
			function successCallback(response) {
				$scope.page = response.data.data[0];
				// console.log($scope.page);
				$scope.$broadcast('dataTitleHeaderLoaded');
			
				// SEO title | description
				document.title = $scope.page.title;
				var desciptionTag = 'Contactez le studio de design graphique Pam&Jenny !';
				$('meta[name=description]').attr('content', desciptionTag);

			}
		);
	};

}]);


// MAIN CONTROLLER
// ===============
app.controller('mainCtrl', ['$rootScope', '$scope', '$http', '$route', '$location', '$routeParams', function($rootScope, $scope, $http, $route, $location, $routeParams){
	// console.log('mainCtrl');
	
	$scope.categories = [];
	$scope.categoriesClassName = '';
	
	// load categories
	$scope.loadCats = function(config){
		$http.get('categories.json', config).then(
			function successCallback(response) {

				// get cats
				$scope.categories = response.data.data;
				// console.log($scope.categories);

				// get class name list
				for (var i = 0; i < $scope.categories.length; i++) {
					$scope.categoriesClassName = $scope.categoriesClassName + ' ' + $scope.categories[i].slug;
				}
			}
		);
	};
	$scope.loadCats();

}]);


// WORK CONTROLLER
// ===============
app.controller('workCtrl', ['$rootScope','$scope', '$http', '$location', function($rootScope,$scope, $http, $location){
	// console.log('workCtrl');

	$scope.works = [];
	$scope.worksImage = [];
	$scope.workDetail = {};


	$scope.loadWorks = function(config){
  	var param = $.param({'display': $scope.display});
		$http.get('works.json', param, config).then(
			function successCallback(response) {

				// get works
				$scope.works = response.data.data;

				for (var i = 0; i < $scope.works.length; i++) {
					for (var c = 0; c < $scope.works[i].covers.length; c++) {
						var tmpWork = jQuery.extend({}, $scope.works[i]);
						tmpWork.cover = $scope.works[i].covers[c];
						$scope.worksImage.push(tmpWork);
					}
				}
			}
		);
	};
	$scope.loadWorks();


	$rootScope.loadWorkDetails = function($uri, config){
		console.log('load work '+$uri);
		$http.get('works/'+$uri+'.json', config).then(
			function successCallback(response) {

				// load workDetails data
				$scope.workDetails = response.data;

				// wrap image details into row
				setTimeout(function(){
					var image__container = $('.article__images .image__container');
					for(var i = 0; i < image__container.length; i+=2) {
					  image__container.slice(i, i+2).wrapAll('<div class="row article__row"></div>');
					}
				}, 200);

				$scope.$broadcast('dataTitleDetailsLoaded');

				// SEO title | description
				document.title = $scope.workDetails.title;
				var desciptionTag = $.parseHTML($scope.workDetails.body)[0].innerText;
				desciptionTag = desciptionTag.substr(0, 160) + '\u2026';
				$('meta[name=description]').attr('content', desciptionTag);
			}
		);

	};


}]);


